var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 44.991 44.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_724",
    "data-name": "\\u7EC4 724",
    transform: "translate(-3141.632 -395.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_723",
    "data-name": "\\u7EC4 723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_328",
    "data-name": "\\u8DEF\\u5F84 328",
    d: "M3162.722,395.344h2.812a2.37,2.37,0,0,0,.338.072,21.419,21.419,0,0,1,9.77,3.107,22.207,22.207,0,0,1,10.636,15.44c.152.817.232,1.647.345,2.471v2.812c-.036.288-.076.576-.107.865a22.553,22.553,0,0,1-18.47,19.876c-.831.151-1.675.234-2.512.349h-2.812c-.549-.068-1.1-.127-1.647-.2a22.544,22.544,0,0,1-19.093-18.371c-.151-.832-.235-1.676-.35-2.514v-2.812c.036-.288.075-.576.106-.865a22.543,22.543,0,0,1,18.558-19.885C3161.1,395.544,3161.913,395.456,3162.722,395.344Zm1.447,9.512,0,.156c-1.859,0-3.719-.034-5.577.011a7.693,7.693,0,0,0-4.2,1.237,6.938,6.938,0,0,0-3.07,5.962c-.076,3.746-.048,7.5-.006,11.243a7.394,7.394,0,0,0,1.23,4.109,6.948,6.948,0,0,0,5.963,3.07c3.746.077,7.5.066,11.242,0a7.09,7.09,0,0,0,5.339-2.284,7.407,7.407,0,0,0,1.853-4.995c.069-3.073.075-6.149.079-9.224a27.105,27.105,0,0,0-.157-2.717,6.783,6.783,0,0,0-6.337-6.313C3168.417,404.937,3166.29,404.936,3164.169,404.856Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_329",
    "data-name": "\\u8DEF\\u5F84 329",
    d: "M3164.129,428.47c-1.946-.055-3.9-.061-5.836-.178a4.494,4.494,0,0,1-4.6-4.623c-.106-3.918-.074-7.843,0-11.763a4.327,4.327,0,0,1,2.383-3.938,6.015,6.015,0,0,1,2.844-.64c3.688,0,7.378-.044,11.062.073a4.435,4.435,0,0,1,4.581,4.586q.156,5.856,0,11.719a4.521,4.521,0,0,1-4.552,4.59c-.977.07-1.959.1-2.939.114s-1.962,0-2.942,0Zm6.627-10.64a6.629,6.629,0,1,0-6.64,6.638A6.616,6.616,0,0,0,3170.756,417.83Zm1.812-6.883a1.544,1.544,0,1,0-1.57,1.539A1.537,1.537,0,0,0,3172.568,410.947Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_330",
    "data-name": "\\u8DEF\\u5F84 330",
    d: "M3164.122,413.535a4.3,4.3,0,1,1-4.3,4.3A4.31,4.31,0,0,1,3164.122,413.535Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramOutlined);
export default __webpack_public_path__ + "static/media/instagram_outlined.09fa960a.svg";
export { ForwardRef as ReactComponent };